/**
 * description:
 * Homepage "Join Our Newsletter" section with an inline email
 * signup wired directly to the FASA Mailchimp list.
 */
import { useState } from "react";
import { Box, Button, TextField, Typography } from "@mui/material";
import MailchimpSubscribe from "react-mailchimp-subscribe";
import { mustard } from "../../../styles.tsx";

const mailchimpUrl =
  "https://vtfasa.us20.list-manage.com/subscribe/post?u=b0af669fc48f9e20fbfec22dd&id=15d05ee128&f_id=004a78eaf0";

const stripHtml = (html) => html?.replace(/<[^>]*>/g, "") ?? "";

const NewsletterForm = ({ subscribe, status, message }) => {
  const [email, setEmail] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (email) subscribe({ EMAIL: email });
  };

  if (status === "success") {
    return (
      <Typography variant="body1" sx={{ color: "primary.main" }}>
        You're subscribed — welcome to the fam!
      </Typography>
    );
  }

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ display: "flex", flexDirection: "column", gap: "12px", alignItems: "center" }}>
      <Box sx={{ display: "flex", gap: "10px", flexWrap: "wrap", justifyContent: "center", alignItems: "center" }}>
        <TextField
          type="email"
          required
          placeholder="your@email.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          size="small"
          sx={{
            bgcolor: "background.default",
            borderRadius: "4px",
            minWidth: "220px",
          }}
        />
        <Button
          type="submit"
          disabled={status === "sending"}
          variant="contained"
          color="secondary"
          sx={{ px: "24px" }}
        >
          <Typography variant="h6" sx={{ color: "background.default" }}>
            {status === "sending" ? "Subscribing..." : "Subscribe"}
          </Typography>
        </Button>
      </Box>
      {status === "error" && (
        <Typography variant="body1" sx={{ color: "secondary.main" }}>
          {stripHtml(message) || "Something went wrong, please try again."}
        </Typography>
      )}
    </Box>
  );
};

const NewsletterSection = () => {
  return (
    <Box sx={{ bgcolor: mustard, px: { xs: "20px", md: "48px" }, py: { xs: "48px", md: "90px" } }}>
      <Box
        sx={{
          maxWidth: "1200px",
          mx: "auto",
          display: "grid",
          gridTemplateColumns: { xs: "1fr", md: "1.3fr 1fr" },
          gap: { xs: "32px", md: "48px" },
          alignItems: "center",
        }}
      >
        <Box>
          <Typography variant="h1" sx={{ color: "primary.main" }}>
            Join Our Newsletter
          </Typography>
          <Typography variant="body1" sx={{ maxWidth: "520px", mt: "24px" }}>
            Get updates about upcoming events, sign-ups, and news straight to
            your inbox!
          </Typography>
        </Box>
        <Box sx={{ textAlign: "center" }}>
          <Typography variant="h6" sx={{ color: "primary.main", mb: "20px" }}>
            Stay in the loop
          </Typography>
          <MailchimpSubscribe
            url={mailchimpUrl}
            render={({ subscribe, status, message }) => (
              <NewsletterForm subscribe={subscribe} status={status} message={message} />
            )}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default NewsletterSection;
